export default "__VITE_ASSET__CvpOTGoj__";